module.exports = __webpack_public_path__ + "static/media/quiz-img.910e01f7.png";